import Api from "../axios";

export const getLeaveLogList = async ({ employee_id, startDate, endDate, financial_year }) => {
  return Api.get(
    `/leave_logs_list?employee_id=${employee_id}&start_date=${startDate}&end_date=${endDate}&financial_year=${financial_year}`
  );
};
